//const localUser = JSON.parse(localStorage.getItem('adminState'))

import { authApi, paymentApi, userApi, defaultApi } from '@/service/api'

import { POST_PURCHASE_ORDER, GET_PURCHASE_ORDER_LIST, GET_REVENUE_SOURCE } from '@/store/_actiontypes'

import { SET_PACKAGE } from '@/store/_mutationtypes'

const state = {
    package_list: null,
}

const actions = {
    [POST_PURCHASE_ORDER]({ commit }, payload) {
        return new Promise((resolve, reject) => {
            // Extract the parameters from the payload
            const urlParams = payload._params;
            // The rest of the payload will be the request body
            const requestBody =  payload.OrderDetails  // Create a shallow copy to avoid modifying original payload
            delete requestBody._params; // Remove _params from the body

            paymentApi.post('/api/v2/AddDcl', requestBody, { params: urlParams })
                .then(response => {

                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    [GET_PURCHASE_ORDER_LIST]({ commit }, payload) {
        return new Promise((resolve, reject) => {
        paymentApi.get('/api/Declarations', { params: payload })
            .then(response => {      
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },


    [GET_REVENUE_SOURCE]({ commit }, payload) {
        return new Promise((resolve, reject) => {
        paymentApi.get('/Api/RevSources', { params: payload })
            .then(response => {      
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    }
}


export const payment = {
    namespaced: true,
    state,
    actions
}